import {FC} from 'react';
import {mapStore} from "../../../Map3d/map.store";
import {HotelCardProps} from '../hotelCard.types';
import './style.scss';

export const HotelCardView: FC<HotelCardProps> = ({room, index}) => (
    <div className="hotelCardContent">
      <div>
        <h2 className="hotelCardTitle">{room.name}</h2>
        <p className="hotelLocation">
          {room.countryData.countryLocation.city.name + ", " + room.countryData.countryName}
        </p>
        <p className="hotelDesc">{room.distance} km from centre</p>
        <span
            onClick={(e) => {
              e.stopPropagation()
              mapStore.searchInMap([[room.location.latitude, room.location.longitude],])
            }}
            className="hotelOnMap">
          Show on map
        </span>
      </div>


      <div className="hotelCardCellWrapper">
        <div className="hotelCardCell">
          <span className="hotelCardCellInfo">2 extra-large double beds</span>
        </div>
        <div className="hotelCardCell">
          <span className="hotelCardCellInfo">2 extra-large double beds</span>
        </div>
      </div>
      <div className="hotelCardFooter">
        <div className="hotelCardFooterCell">
          <p className="hotelPrice">154 FTN </p>
          <p className="hotelExtraInfo">9 night | 2 adults, 2 children</p>
        </div>
        <div className="hotelCardFooterCell">
          <p className="hotelRating">
              <i className="icon-star"/>
              {room.star}
          </p>
        </div>
      </div>
    </div>
);
